export enum ShaderType {
  VertexShader = WebGLRenderingContext.VERTEX_SHADER,
  FragmentShader = WebGLRenderingContext.FRAGMENT_SHADER
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/ShaderType.ts